import { render } from "./EditEmployee.vue?vue&type=template&id=64217bdf&scoped=true"
import script from "./EditEmployee.vue?vue&type=script&lang=js"
export * from "./EditEmployee.vue?vue&type=script&lang=js"

import "./EditEmployee.vue?vue&type=style&index=0&id=64217bdf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64217bdf"]])

export default __exports__